import React, { useEffect } from 'react'
import MyButton from '../../../UI/form/MyButton'
import ErrorMessage from '../../../../helpers/message/ErrorMessage'
import SuccessMessage from '../../../../helpers/message/SuccessMessage'
import { useState } from 'react'
import ScannerWrap from '../../../scanner/ScannerWrap'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../UI/spiner/MySpiner'
import { changeWorkPlaceAPI, checkChangeWorkPlaceAPI } from '../../../../api/workPlace/workPlaceAPI'
import UserWorkPlaceResult from './result/UserWorkPlaceResult'

const UserWorkPlaceForm = () => {

    const [scanResultTemp, setScanResultTemp] = useState('')
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (scanResultTemp) {
            changeWorkPlace()
        }
    }, [scanResultTemp])

    // useEffect(() => {
    //     if (reset) { // Якщо треба скинути
    //         setScanResultTemp('')
    //         setError('')
    //     }
    // }, [reset])

    const changeWorkPlace = () => {
        setError('')
        setLoading(true)
        setData(null)
        checkChangeWorkPlaceAPI({ 
            scaned: scanResultTemp 
        }).then(data => {
            setData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myBlock__content'>
        <p>
            Відскануйте QR-код за допомогою сканера нижче
        </p>

        <ErrorMessage 
            error={error}
        />
        <SuccessMessage 
            success={success}
        />

        {
            process.env.REACT_APP_DEV_TYPE === 'DEV' ?
                <MyButton
                    // Старое
                    // onClick={e => setScanResultTemp('warehouse.1.15899371-318c-4ff0-9c10-9c0e57485b4b')} // Склад НВ
                    // onClick={e => setScanResultTemp('factory.1.26a26f5a-6807-4759-9be9-bc2c1f1506a6')} // Діма

                    // Нове - підрозділи загальні
                    // onClick={e => setScanResultTemp('cadaf007-ebec-4e14-94c3-4697bf31f3d3')} // Діма
                    // onClick={e => setScanResultTemp('8ffb8565-4b56-4bc5-9ab7-37deedf75e36')} // НВ
                    onClick={e => setScanResultTemp('a4c87efd-9b37-427d-8dd9-0b6eb31a5fde')} // Офіс головний
                >
                    Без камери - умовний сканер - ТИМЧАСОВО
                </MyButton>
            : ''
        }

        <ScannerWrap
            setResultText={setScanResultTemp}
            isCameraOnly={true}
            // reset={reset}
            // setReset={setReset}
        />

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            data ?
                <UserWorkPlaceResult 
                    result={data}
                />
            : ''
        }

        {/* <MyButton
            // onClick={add}
            // disabled={loading ? true : false}
        >
            Відкрити сканер
        </MyButton> */}
    </div>
  )
}

export default UserWorkPlaceForm